import * as z from 'zod';

import { normalizeCountryCode } from '../../validations/CountryCodes';

export type ExportableAddress = z.infer<typeof ExportableAddress>;
export const ExportableAddress = z.object({
  line1: z.string(),
  line2: z.string().optional(),
  line3: z.string().optional(),
  line4: z.string().optional(),
  locality: z.string(),
  region: z.string(),
  postcode: z.string(),
  county: z.string().optional(),
  country: z.string().transform(normalizeCountryCode),
});
